import React, { useState, useEffect } from "react";
import "./index.scss";
import { getPhone } from "../../../../utils/msg";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
function Electronic() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const scenarioContent = t("residency.space_part2", {
    returnObjects: true,
  });
  const [partTwoActive, setPartTwoActive] = useState(
    scenarioContent.list_two[0]
  );
  const [partTwoActiveIndex, setPartTwoActiveIndex] = useState(0);
  const handleClick = (index) => {
    setPartTwoActiveIndex(index);
    setPartTwoActive(scenarioContent.list_two[index]);
  };
  return (
    <div className="scenario_">
      <div className="edition_solution edition_solution_top">
        <div className="edition_solution_title">
          <div>{scenarioContent.title}</div>
        </div>
      </div>
      <div className="scenario_con">
        {scenarioContent.list_one.map((item0, index0) => {
          return (
            <div
              className={`scenario_li ${
                partTwoActiveIndex == index0 ? "scenario_li_active" : null
              }`}
              key={index0}
              onClick={() => {
                handleClick(index0);
              }}
            >
              <div className="scenario_li_img">
                <img
                  src={
                    partTwoActiveIndex == index0
                      ? item0.iconUrl2
                      : item0.iconUrl
                  }
                  alt=""
                />
              </div>
              <div className="scenario_li_til" style={language === 'zh'? {fontSize: '18px'}:{fontSize: '16px'}} >{item0.title}</div>
            </div>
          );
        })}
      </div>
      <div className="scenario_detail">
        <div className="scenario_detail_con">
          <div className="scenario_det_left">
            <div className="scenario_det_l_title">{partTwoActive.title}</div>
            <p className="scenario_det_l_subhead">{partTwoActive.subhead}</p>
            {partTwoActive.list_two_list?.map((item, index) => {
              return (
                <div key={index} className="scenario_det_l_listItem">
                  <div className="scenario_det_l_listItemDot">
                    <img src={partTwoActive.dot} alt="" />
                  </div>
                  <div className="scenario_det_l_listItemCon">{item}</div>
                </div>
              );
            })}
          </div>
          <div className="scenario_det_right">
            <img src={partTwoActive.imgUrl} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Electronic;
